module.exports = __webpack_public_path__ + "media/images/ibjjf/bg-check-2-035d760b729dfecf877f878e3dea5308.svg";